/* eslint-disable jsx-a11y/href-no-hash */
/* eslint-disable no-unused-vars */
import React, { PureComponent, Fragment } from 'react'
import styled from 'styled-components'
import {
  Header,
  Footer,
  HeaderParagraph,
  Product,
  Button,
  CarouselComponent,
  Input,
  Container,
  ContainerTitle,
  ContainerSubTitle,
  FlexContainer,
  Icon,
  OurTeamMobileView,
  ColumnWrapper,
  BubbleTop,
  BubbleWrapper,
  TeamInfo,
  CircleImage,
  BigCircle,
  MobileFooter,
  BodyWrapper,
  CollapseWrapper,
  Backgroundwrapper,
  OurClient
} from '../components'
import { Collapse } from 'react-collapse'
import { Helmet } from 'react-helmet'

// import map from '../static/map.png'
import VideoLoader from '../static/video-screenhost.jpg'
const TopImageWrapper = styled.section`
  display: flex;
  flex-direction: column;
  position: relative;
  background-image: url(${VideoLoader});
  background-repeat: no-repeat;
  background-size: cover;

  // max-width: 2560px;
  margin: 0 auto;

  & > div:first-child {
    background-repeat: no-repeat;
    background-size: cover;
    background-position: center center;
    background-attachment: fixed;
    overflow: hidden;
    z-index: 0;
    position: relative;
    height: calc(82vh - 50px);
    // width: calc(100vw - 20px);
    width: 100%;
    @media (max-width: 767px) and (min-width: 600px) {
      height: auto;
    }
    @media (max-width: 600px) {
      height: calc(75vh - 50px);
    }
    @media (min-width: 240px) and (max-width: 540px) {
      height: calc(100vh - 50px);
    }
    & > video {
      object-fit: cover;
      width: 100%;
      min-height: 100%;
      height: auto;
      min-width: 100%;
      width: auto;
      height: auto;
      z-index: 1;
      background-size: cover;
      display: inline-block;
      vertical-align: baseline;
      object-fit: contain;
    }
  }
  @media (max-width: 768px) {
    & > div:first-child {
      & > video {
        object-fit: cover;
        width: 100%;
        min-height: 100%;
        height: auto;
      }
    }
  }
  & > div:last-child {
    margin: 0;
    padding: 80px 20px;
    height: 100%;
    @media (min-width: 240px) and (max-width: 599px) {
      padding-top: 40px;
      padding-bottom: 40px;
    }
    & > h1 {
      font-size: 28px;
      font-weight: 500;
    }
    & > p {
      font-size: 16px;
      font-weight: 300;
      line-height: 1.38;
      letter-spacing: 0.1px;
      color: #ffffff;
      padding: 10px 0 40px 0;
    }
    & > form {
      flex-direction: column;
      & > div > div {
        top: 14%;
      }
      & input {
        width: 100%;
        margin-bottom: 10px;
      }
      & button {
        width: 100%;
      }
    }
  }
  @media (max-width: 640px) {
    & > div:last-child {
      padding-left: 10px;
      padding-right: 10px;
    }
  }
`

const ButtonHolder = styled.div`
  margin-top: 40px;
`
const FormWrapper = styled.form`
  display: flex;
  @media (max-width: 520px) {
    display: flex;
    flex-direction: column;
    flex-wrap: wrap;
    width: 100%;
    & > div > input {
      width: 100%;
      margin-bottom: 10px;
    }
    & > button {
      width: 100%;
      border-radius 4px;
    }
  }
`
const BannerContent = styled.div`
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  z-index: 2;
  // height: calc(65vh - 50px);
  // width: 100vw;
  & div.bannerWrapper {
    padding-left: 80px;
    padding-right: 80px;
    padding-top: 60px;
    max-width: 1366px;
    margin: auto;
    @media (max-width: 992px) {
      padding-left: 20px;
      padding-right: 20px;
    }
    @media (max-width: 768px) {
      padding: 0px;
      display: flex;
      height: 100%;
    }
    & > div {
      max-width: 600px;
      @media (max-width: 768px) {
        width: 100%;
        max-width: 100%;
        justify-content: center;
        display: flex;
        flex-direction: column;
      }
      & > h1 {
        font-size: 48px;
        line-height: 1.27;
        color: #ffffff;
        text-shadow: 0px 2px 2px rgba(00, 00, 00, 0.4);
      }
      & > p {
        font-size: 18px;
        font-weight: normal;
        line-height: 1.53;
        color: #ffffff;
        text-shadow: 0px 1px 1px rgba(00, 00, 00, 0.4);
        padding: 10px 0 30px 0;
      }
      @media (max-width: 520px) {
        & > h1 {
          font-size: 28px;
        }
        & > p {
          font-size: 16px;
          font-weight: 300;
        }
      }
    }
  }
`

const SecondSection = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  // margin-bottom: 70px;
  & + div {
    & > img {
      max-width: 100%;
    }
  }
  & ~ div {
    padding-top: 80px;
  }
  @media (max-width: 768px) {
    & ~ div {
      padding-top: 0;
    }
    // margin-bottom: 30px;
  }
  & ~ div:nth-child(odd) {
    flex-direction: row-reverse;
    @media (max-width: 840px) {
      flex-direction: column;
      align-items: center;
    }
  }
  & ~ div:last-child {
  }
`

const TeamWrapper = styled.section`
  max-width: 1366px;
  width: 100%;
  margin: 0 auto;
  @media (max-width: 992px) {
    padding-left: 20px;
    padding-right: 20px;
    padding-top: 40px;
    padding-bottom: 40px;
  }
  & + section {
    display: flex;
    flex-direction: column;
    align-items: center;
    & > p {
      padding-top: 10px;
    }
    & > button {
      margin-top: 30px;
    }
  }
`

const TeamSection = styled.section`
  padding: 80px;
  & > div {
    padding-top: 80px;
    @media (max-width: 640px) {
      padding-top: 30px;
    }
    & > div > p:nth-child(3) {
      margin-bottom: 64px !important;
      @media (max-width: 640px) {
        margin-bottom: 20px !important;
      }
    }
  }
  @media (max-width: 992px) {
    padding-left: 20px;
    padding-right: 20px;
  }
  @media (max-width: 768px) {
    padding: 0;
  }
`

const ContainerLeft = styled.div`
  flex-basis: calc(55% - 60px);
  padding-right: 60px;
  @media (max-width: 992px) {
    padding: 0;
    flex-basis: calc(100% - 0px);
  }
  & > p {
    font-size: 16px;
    line-height: 1.6;
    letter-spacing: 0.8px;
    color: #333333;
    padding-bottom: 4px;
    font-weight: 500;
  }
  & > p:nth-child(2) {
    font-size: 38px;
    font-weight: 400;
    line-height: 1.2;
    padding-bottom: 10px;
    letter-spacing: 2.4px;
    font-weight: 400;
    color: #333333;
    margin: 0;
  }
  & > p:nth-child(3) {
    // width: 448px;
    font-weight: 400;
    margin-bottom: 20px;
    color: #666666;
  }
  @media (max-width: 768px) {
    & > p {
      font-size: 14px;
    }
    & > p:nth-child(2) {
      font-size: 24px;
    }
  }
`
const ContainerRight = styled.div`
  flex-basis: 45%;
  & > div:first-child {
    display: none;
    @media (max-width: 768px) {
      display: block;
    }
  }
  & > div:last-child {
    display: block;
    @media (max-width: 768px) {
      padding-top: 30px;
    }
  }
`
const MobileClientLogo = styled.li`
  @media (max-width: 768px) {
    display: ${props => (props.MobileLogo === true ? 'none!important' : 'block')};
  }
`

const ButtonMLogo = styled.button`
  width: 138px;
  margin: auto;
  height: 38px;
  background: transparent;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.2);
  line-height: 1;
  color: #333333;
  cursor: pointer;
  text-transform: uppercase;
  font-size: 14px;
  letter-spacing: 1px;
  box-shadow: none;
  @media (min-width: 767px) {
    display: none;
  }
`
const ButtonComponent = styled.button`
  width: ${props => (props.width ? props.width : 186)}px;
  height: ${props => (props.height ? props.height : 48)}px;
  background: ${props => (props.background ? props.background : '#333333')};
  border-radius: ${props => (props.radius ? props.radius : '4px')};
  border: ${props => (props.border ? props.border : 'none')};
  line-height: 1;
  letter-spacing: 1px;
  color: ${props => (props.color ? props.color : '#fff')};
  cursor: pointer;
  text-transform: ${props => (props.transform ? props.transform : 'uppercase')};
  font-family: Montserrat;
  font-size: 14px;
  line-height: 1;
  letter-spacing: 1px;
  box-shadow: ${props => (props.shadow ? props.shadow : 'none')};
  -webkit-tap-highlight-color: transparent;
  &:hover {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.08);
  }
  &:focus {
    box-shadow: 0 8px 16px 0 rgba(0, 0, 0, 0.08);
    outline: none;
  }
  @media (max-width: 768px) {
    height: 38px;
    font-size: 12px;
    font-weight: 500;
    letter-spacing: 1.1px;
  }
`

const mql = window.matchMedia('(min-width: 769px)')

export class Home extends PureComponent {
  state = {
    bigImage: 100,
    medImage: 65,
    smallImage: 40,
    display: false,
    active: 'first',
    collapse: false,
    mobileView: false,
    MobileLogo: true,
    MobileLogoText: 'View More'
  }
  MobileLogoButton = e => {
    this.setState({ MobileLogoText: this.state.MobileLogo ? 'Less' : 'View More' })
    this.setState({ MobileLogo: !e })
  }

  handleBubbleTop = e => {
    this.setState({ bigImage: 270, smallImage: 270, medImage: 270, display: true, active: e })
  }
  handleTeamInfo = () => {
    if (this.state.mobileView === false) {
      this.setState({ display: false, bigImage: 70, medImage: 55, smallImage: 40 })
    } else {
      this.setState({ display: false, bigImage: 100, medImage: 65, smallImage: 40 })
    }
  }
  /* componentDidMount = () => {
    this.mediaWidthChange()
    mql.addListener(this.mediaWidthChange)
  }
  componentWillUnmount = () => {
    mql.removeListener(this.mediaWidthChange)
  }
  mediaWidthChange = () => {
    if (mql.matches) {
      this.setState({ mobileView: false })
    } else {
      this.setState({ display: false, bigImage: 70, smallImage: 40, medImage: 55, mobileView: true })
    }
  } */
  render() {
    return (
      <Fragment>
        <Helmet>
          <meta charSet="utf-8" />
          <title>SAAS Service Provider | Accounting Software | Digital Marketing Agency | 8om</title>
          <meta
            name="description"
            content="A SaaS Service Provider and Digital Marketing Agency with outstanding ERP Software, accounting software and varying digital marketing services to choose from."
          />
          <meta
            name="keywords"
            content="accounting software, ERP Software, saas services providers, digital marketing agency"
          />
        </Helmet>
        <Header />
        <TopImageWrapper>
          <div>
            <video playsInline loop autoPlay muted>
              <source src="https://s3.ap-south-1.amazonaws.com/8om-website/official-loop.mp4" type="video/mp4" />
            </video>
          </div>
          <BannerContent>
            <div className="bannerWrapper">
              <div>
                <h1>Grow Up Your Business</h1>
                <p>
                  At 8om we have worked hard to create for you a platform to bring efficiency to your business and make
                  your business insights better.
                </p>
                <form action="https://formspree.io/harsh@8om.io" method="POST">
                  <FormWrapper>
                    <Input type="email" name="_replyto" icon="email" placeholder="Email" changeColor={'#35cc62'} />
                    <input type="hidden" name="" value="/" />
                    <Button
                      radius={'0 4px 4px 0'}
                      title={'Request Demo'}
                      type="submit"
                      formAction="/contact"
                      method="POST"
                    />
                  </FormWrapper>
                </form>
              </div>
            </div>
          </BannerContent>
        </TopImageWrapper>
        <Container padding={'80px 0px'}>
          <SecondSection>
            <HeaderParagraph
              headerColor={'#333333'}
              header={'Our Solutions'}
              alignCenter
              paragraph={
                'We aim to give you world class solutions by bringing you best fit of tools that you need  to make your business faster and easier'
              }
              headerFontSize={'48px'}
            />
          </SecondSection>
          <Product
            contentPadding="32px 0 0 70px"
            img={require('../static/extract_demo.png')}
            title={'DATA EXTRACTION'}
            productName={'EXTRACT'}
            featureOne={'Web Scraping Automation & Data Feed Extraction.'}
            featureTwo={'Deploy & Scale your web crawlers with ease.'}
            featureThree={'Manage Crawling Services for all kinds of industries.'}
            featureFour={'Get Combined Data Feeds from 1000s of sources.'}
            redirectTo={'https://extract.8om.io'}
            titleName={'Try Now'}
          />

          <Product
            contentPadding="32px 0 0 70px"
            img={require('../static/trckr_demo.png')}
            title={'INVENTORY MANAGEMENT'}
            productName={'TRCKR'}
            featureOne={'Real Time End to End Inventory Tracking.'}
            featureTwo={'Track your inventory between your channel partners.'}
            featureThree={'Acquire and Analyse end customers data'}
            featureFour={'Increase sales & reduce operating cycle'}
            redirectTo={'https://trckr.8om.io'}
            titleName={'Try Now'}
          />

          <Product
            contentPadding="32px 0 0 70px"
            img={require('../static/books_demo.png')}
            title={'ACCOUNTING SOFTWARE'}
            productName={'BOOKS'}
            featureOne={'Track all of your accounting activities'}
            featureTwo={'Never lose a sale with the help of POS'}
            featureThree={'Manage your inventory more accurately'}
            featureFour={'Carry on where you left off  with its offline features '}
            redirectTo={'/books'}
            titleName={'Read More'}
          />

          {/*<Product
            contentPadding="32px 0 0 70px"
            img={require('../static/laptop.jpg')}
            title={'INVENTORY MANAGEMENT'}
            productName={'BOOKS'}
            featureOne={'Real Time End to End Inventory Tracking.'}
            featureTwo={'Track your inventory between your channel partners.'}
            featureThree={'Acquire and Analyse end customers data'}
            featureFour={'Increase sales & reduce operating cycle'}
            redirectTo={'#'}
            titleName={'Try Now'}
          />*/}
        </Container>
        <Container normal background={'#fafbfc'} padding={'80px 0 60px 0'}>
          <ContainerTitle>Our Clients Around The World</ContainerTitle>
          <ContainerSubTitle>
            Our clients are valuable to us and we’re always inspired by them and their need to make their business
            better.
          </ContainerSubTitle>
          <Backgroundwrapper>
            <OurClient>
              <ul>
                <li>
                  <a href="https://www.bonobology.com/" target="_blank" rel="noopener noreferrer nofollow">
                    <img src={require('../static/client_logo/bonobology.jpg')} alt="Bonobology" />
                  </a>
                </li>
                {/*<li>
                  <a href="#">
                    <img src={require('../static/client_logo/home_registry.jpg')} alt="Home Registry" />
                  </a>
                </li>
                <li>
                  <a href="http://leveragegroup.in/" target="_blank" rel="noopener noreferrer nofollow">
                    <img src={require('../static/client_logo/leverage_group.jpg')} alt="Leverage Group" />
                  </a>
               </li>
                <li>
                  <a href="http://mtechinfo.in" target="_blank" rel="noopener noreferrer nofollow">
                    <img src={require('../static/client_logo/m-tech.jpg')} alt="M-tech" />
                  </a>
                </li> */}
                <MobileClientLogo MobileLogo={this.state.MobileLogo}>
                  <a href="https://thescalelabs.com/" target="_blank" rel="noopener noreferrer">
                    <img src={require('../static/client_logo/scale_labs.jpg')} alt="Scalelabs" />
                  </a>
                </MobileClientLogo>

                <MobileClientLogo MobileLogo={this.state.MobileLogo}>
                  <a href="https://www.techrobotix.com/" target="_blank" rel="noopener noreferrer">
                    <img src={require('../static/client_logo/techrobotix.jpg')} alt="Munafamart" />
                  </a>
                </MobileClientLogo>

                <MobileClientLogo MobileLogo={this.state.MobileLogo}>
                  <a href="#" target="_blank" rel="noopener noreferrer">
                    <img src={require('../static/client_logo/tanoshii-trails.jpg')} alt="Munafamart" />
                  </a>
                </MobileClientLogo>
                <MobileClientLogo MobileLogo={this.state.MobileLogo}>
                  <a href="#" target="_blank" rel="noopener noreferrer">
                    <img src={require('../static/client_logo/baked-pizza.jpg')} alt="Munafamart" />
                  </a>
                </MobileClientLogo>

                <MobileClientLogo MobileLogo={this.state.MobileLogo}>
                  <a href="https://munafamart.co.in/" target="_blank" rel="noopener noreferrer">
                    <img src={require('../static/client_logo/munafamart.png')} alt="Munafamart" />
                  </a>
                </MobileClientLogo>

                <MobileClientLogo MobileLogo={this.state.MobileLogo}>
                  <a href="https://teafloor.com/" target="_blank" rel="noopener noreferrer">
                    <img src={require('../static/client_logo/teafloor.png')} alt="Teafloor" />
                  </a>
                </MobileClientLogo>
                <MobileClientLogo MobileLogo={this.state.MobileLogo}>
                  <a href="http://www.vikasspool.com/" target="_blank" rel="noopener noreferrer nofollow">
                    <img src={require('../static/client_logo/vikas_spools.jpg')} alt="Vikas Spools" />
                  </a>
                </MobileClientLogo>
                <MobileClientLogo MobileLogo={this.state.MobileLogo}>
                  <a href="https://trulymadly.com/" target="_blank" rel="noopener noreferrer nofollow">
                    <img src={require('../static/client_logo/truly_madly.jpg')} alt="Truly Madly" />
                  </a>
                </MobileClientLogo>
                <MobileClientLogo MobileLogo={this.state.MobileLogo}>
                  <a href="https://www.wickey.co.uk/" target="_blank" rel="noopener noreferrer nofollow">
                    <img src={require('../static/client_logo/wickey.jpg')} alt="Wickry" />
                  </a>
                </MobileClientLogo>
              </ul>
              <ButtonMLogo onClick={() => this.MobileLogoButton(this.state.MobileLogo)}>
                {this.state.MobileLogoText}
              </ButtonMLogo>
            </OurClient>
          </Backgroundwrapper>
        </Container>
        <Container background="#fafbfc" padding={'50px 0'}>
          <ContainerTitle>Get In Touch</ContainerTitle>
          <ContainerSubTitle paddingBottom="30px">
            Give your business the best tools to optimize your processes.
          </ContainerSubTitle>
          <form action="/contact" method="POST">
            <FormWrapper>
              <Input type="email" name="_replyto" icon="email" placeholder="Email" changeColor={'#35cc62'} />

              <Button
                radius={'0 4px 4px 0'}
                title={'Contact Us'}
                background={'#35cc62'}
                type="submit"
                formAction="/contact"
                method="POST"
              />
            </FormWrapper>
          </form>
        </Container>
        <TeamWrapper>
          <TeamSection>
            <HeaderParagraph
              headerColor={'#333333'}
              alignCenter
              header={'Our Team'}
              paragraph={
                'We’re constantly working on curating the best team suited to deliver high performance across industries. Meet our enthusiasts.'
              }
              headerFontSize={'38px'}
            />

            <FlexContainer>
              <ContainerLeft>
                <p>OUR STRENGTH</p>
                <p align="left">Know more about our Work Environment</p>
                <p>
                  We believe in making our employees feel like home at their workspace and work together like a family,
                  acknowledging everyone’s presence.
                </p>
                <a href="/about/#careers">
                  <Button
                    background="#fff"
                    border={'1px solid rgba(0, 0, 0, 0.2)'}
                    width={276}
                    color={'#333333'}
                    title={'View current openings'}
                  />
                </a>
              </ContainerLeft>
              <ContainerRight>
                {/* <OurTeamMobileView /> */}
                <BigCircle>
                  <img src={require('../static/team.jpg')} alt="Team" />
                </BigCircle>
                {/*<BigCircle>
                  <ColumnWrapper>
                    <BubbleTop
                      imageSize={`${this.state.bigImage}px`}
                      tx={0}
                      ty={0}
                      active={this.state.active === 'first'}>
                      <BubbleWrapper onClick={() => this.handleBubbleTop('first')}>
                        <CircleImage imageSize={this.state.active === 'first' && `${this.state.bigImage}px`}>
                          <img src={require('../static/work1.png')} alt="team" />
                        </CircleImage>
                      </BubbleWrapper>
                      <TeamInfo show={this.state.active === 'first' && this.state.display}>
                        <div onClick={() => this.handleTeamInfo()}>X</div>
                        <p>Front-end Developer</p>
                        <h4>Saurav</h4>
                        <a href="#">
                          <Icon icon="linkedin" />
                        </a>
                      </TeamInfo>
                    </BubbleTop>
                    <BubbleTop
                      imageSize={`${this.state.bigImage}px`}
                      tx={0}
                      ty={0}
                      active={this.state.active === 'second'}>
                      <BubbleWrapper onClick={() => this.handleBubbleTop('second')}>
                        <CircleImage imageSize={this.state.active === 'second' && `${this.state.bigImage}px`}>
                          <img src={require('../static/work1.png')} alt="team" />
                        </CircleImage>
                      </BubbleWrapper>
                      <TeamInfo show={this.state.active === 'second' && this.state.display}>
                        <div onClick={() => this.handleTeamInfo()}>X</div>
                        <p>Front-end Developer</p>
                        <h4>Saurav</h4>
                        <a href="#">
                          <Icon icon="linkedin" />
                        </a>
                      </TeamInfo>
                    </BubbleTop>
                    <BubbleTop
                      imageSize={`${this.state.bigImage}px`}
                      tx={0}
                      ty={0}
                      active={this.state.active === 'third'}>
                      <BubbleWrapper onClick={() => this.handleBubbleTop('third')}>
                        <CircleImage imageSize={this.state.active === 'third' && `${this.state.bigImage}px`}>
                          <img src={require('../static/work1.png')} alt="team" />
                        </CircleImage>
                      </BubbleWrapper>
                      <TeamInfo show={this.state.active === 'third' && this.state.display}>
                        <div onClick={() => this.handleTeamInfo()}>X</div>
                        <p>Front-end Developer</p>
                        <h4>Saurav</h4>
                        <a href="#">
                          <Icon icon="linkedin" />
                        </a>
                      </TeamInfo>
                    </BubbleTop>
                  </ColumnWrapper>
                  <ColumnWrapper>
                    <BubbleTop
                      imageSize={`${this.state.bigImage}px`}
                      tx={0}
                      ty={0}
                      active={this.state.active === 'fourth'}>
                      <BubbleWrapper onClick={() => this.handleBubbleTop('fourth')}>
                        <CircleImage
                          imageSize={
                            this.state.active === 'fourth' && this.state.mobileView === true
                              ? `${this.state.bigImage}px`
                              : '100px'
                          }>
                          <img src={require('../static/work1.png')} alt="team" />
                        </CircleImage>
                      </BubbleWrapper>
                      <TeamInfo show={this.state.active === 'fourth' && this.state.display}>
                        <div onClick={() => this.handleTeamInfo()}>X</div>
                        <p>Front-end Developer</p>
                        <h4>Saurav</h4>
                        <a href="#">
                          <Icon icon="linkedin" />
                        </a>
                      </TeamInfo>
                    </BubbleTop>
                    <BubbleTop
                      imageSize={`${this.state.medImage}px`}
                      tx={0}
                      ty={0}
                      active={this.state.active === 'fifth'}>
                      <BubbleWrapper onClick={() => this.handleBubbleTop('fifth')}>
                        <CircleImage
                          imageSize={
                            this.state.active === 'fifth' && this.state.mobileView === true
                              ? `${this.state.medImage}px`
                              : '65px'
                          }>
                          <img src={require('../static/work2.png')} alt="team" />
                        </CircleImage>
                      </BubbleWrapper>
                      <TeamInfo show={this.state.active === 'fifth' && this.state.display}>
                        <div onClick={() => this.handleTeamInfo()}>X</div>
                        <p>Front-end Developer</p>
                        <h4>Saurav</h4>
                        <a href="#">
                          <Icon icon="linkedin" />
                        </a>
                      </TeamInfo>
                    </BubbleTop>
                    <BubbleTop
                      imageSize={`${this.state.bigImage}px`}
                      tx={0}
                      ty={0}
                      active={this.state.active === 'sixth'}>
                      <BubbleWrapper onClick={() => this.handleBubbleTop('sixth')}>
                        <CircleImage
                          imageSize={
                            this.state.active === 'sixth' && this.state.mobileView === true
                              ? `${this.state.bigImage}px`
                              : '100px'
                          }>
                          <img src={require('../static/work1.png')} alt="team" />
                        </CircleImage>
                      </BubbleWrapper>
                      <TeamInfo show={this.state.active === 'sixth' && this.state.display}>
                        <div onClick={() => this.handleTeamInfo()}>X</div>
                        <p>Front-end Developer</p>
                        <h4>Saurav</h4>
                        <a href="#">
                          <Icon icon="linkedin" />
                        </a>
                      </TeamInfo>
                    </BubbleTop>
                  </ColumnWrapper>
                  <ColumnWrapper>
                    <BubbleTop
                      imageSize={`${this.state.bigImage}px`}
                      tx={0}
                      ty={0}
                      active={this.state.active === 'seventh'}>
                      <BubbleWrapper onClick={() => this.handleBubbleTop('seventh')}>
                        <CircleImage
                          imageSize={
                            this.state.active === 'seventh' && this.state.mobileView === true
                              ? `${this.state.bigImage}px`
                              : '100px'
                          }>
                          <img src={require('../static/work1.png')} alt="team" />
                        </CircleImage>
                      </BubbleWrapper>
                      <TeamInfo show={this.state.active === 'seventh' && this.state.display}>
                        <div onClick={() => this.handleTeamInfo()}>X</div>
                        <p>Front-end Developer</p>
                        <h4>Saurav</h4>
                        <a href="#">
                          <Icon icon="linkedin" />
                        </a>
                      </TeamInfo>
                    </BubbleTop>
                    <BubbleTop
                      imageSize={`${this.state.bigImage}px`}
                      tx={0}
                      ty={0}
                      active={this.state.active === 'eight'}>
                      <BubbleWrapper onClick={() => this.handleBubbleTop('eight')}>
                        <CircleImage
                          imageSize={
                            this.state.active === 'eight' && this.state.mobileView === true
                              ? `${this.state.bigImage}px`
                              : '100px'
                          }>
                          <img src={require('../static/work1.png')} alt="team" />
                        </CircleImage>
                      </BubbleWrapper>
                      <TeamInfo show={this.state.active === 'eight' && this.state.display}>
                        <div onClick={() => this.handleTeamInfo()}>X</div>
                        <p>Front-end Developer</p>
                        <h4>Saurav</h4>
                        <a href="#">
                          <Icon icon="linkedin" />
                        </a>
                      </TeamInfo>
                    </BubbleTop>
                    <BubbleTop
                      imageSize={`${this.state.bigImage}px`}
                      tx={0}
                      ty={0}
                      active={this.state.active === 'nine'}>
                      <BubbleWrapper onClick={() => this.handleBubbleTop('nine')}>
                        <CircleImage
                          imageSize={
                            this.state.active === 'nine' && this.state.mobileView === true
                              ? `${this.state.bigImage}px`
                              : '100px'
                          }>
                          <img src={require('../static/work1.png')} alt="team" />
                        </CircleImage>
                      </BubbleWrapper>
                      <TeamInfo show={this.state.active === 'nine' && this.state.display}>
                        <div onClick={() => this.handleTeamInfo()}>X</div>
                        <p>Front-end Developer</p>
                        <h4>Saurav</h4>
                        <a href="#">
                          <Icon icon="linkedin" />
                        </a>
                      </TeamInfo>
                    </BubbleTop>
                    <BubbleTop
                      imageSize={`${this.state.bigImage}px`}
                      tx={0}
                      ty={0}
                      active={this.state.active === 'tenth'}>
                      <BubbleWrapper onClick={() => this.handleBubbleTop('tenth')}>
                        <CircleImage
                          imageSize={
                            this.state.active === 'tenth' && this.state.mobileView === true
                              ? `${this.state.bigImage}px`
                              : '100px'
                          }>
                          <img src={require('../static/work1.png')} alt="team" />
                        </CircleImage>
                      </BubbleWrapper>
                      <TeamInfo show={this.state.active === 'tenth' && this.state.display}>
                        <div onClick={() => this.handleTeamInfo()}>X</div>
                        <p>Front-end Developer</p>
                        <h4>Saurav</h4>
                        <a href="#">
                          <Icon icon="linkedin" />
                        </a>
                      </TeamInfo>
                    </BubbleTop>
                    <BubbleTop
                      imageSize={`${this.state.bigImage}px`}
                      tx={0}
                      ty={0}
                      active={this.state.active === 'eleventh'}>
                      <BubbleWrapper onClick={() => this.handleBubbleTop('eleventh')}>
                        <CircleImage
                          imageSize={
                            this.state.active === 'eleventh' && this.state.mobileView === true
                              ? `${this.state.bigImage}px`
                              : '100px'
                          }>
                          <img src={require('../static/work1.png')} alt="team" />
                        </CircleImage>
                      </BubbleWrapper>
                      <TeamInfo show={this.state.active === 'eleventh' && this.state.display}>
                        <div onClick={() => this.handleTeamInfo()}>X</div>
                        <p>Front-end Developer</p>
                        <h4>Saurav</h4>
                        <a href="#">
                          <Icon icon="linkedin" />
                        </a>
                      </TeamInfo>
                    </BubbleTop>
                    <BubbleTop
                      imageSize={`${this.state.bigImage}px`}
                      tx={0}
                      ty={0}
                      active={this.state.active === 'twelth'}>
                      <BubbleWrapper onClick={() => this.handleBubbleTop('twelth')}>
                        <CircleImage
                          imageSize={
                            this.state.active === 'twelth' && this.state.mobileView === true
                              ? `${this.state.bigImage}px`
                              : '100px'
                          }>
                          <img src={require('../static/work1.png')} alt="team" />
                        </CircleImage>
                      </BubbleWrapper>
                      <TeamInfo show={this.state.active === 'twelth' && this.state.display}>
                        <div onClick={() => this.handleTeamInfo()}>X</div>
                        <p>Front-end Developer</p>
                        <h4>Saurav</h4>
                        <a href="#">
                          <Icon icon="linkedin" />
                        </a>
                      </TeamInfo>
                    </BubbleTop>
                  </ColumnWrapper>
                  </BigCircle>*/}
              </ContainerRight>
            </FlexContainer>
          </TeamSection>
        </TeamWrapper>
        {/* <WorkEnvironmentWrapper>
          <HeaderParagraph
            headerColor={'#333333'}
            headerFontSize={'38px'}
            header={'Our Work Environment'}
            paragraph={
              'We believe in making our employees feel like home at their workspace and work together like a family, acknowledging everyone’s presence.'
            }
            alignCenter
          />
          <CarouselComponent carouselType="home" />
        </WorkEnvironmentWrapper>
        */}
        <BodyWrapper>
          <Footer />
          <MobileFooter />
        </BodyWrapper>
      </Fragment>
    )
  }
}



// WEBPACK FOOTER //
// ./src/pages/Home.js